import * as types from '../constants/ActionTypes';
import Patient from '../model/entity/dicom/Patient';

const initialState = new Patient();

export default (patient: Patient = initialState, action: Object) => {
  switch (action.type) {
    case types.SET_PATIENT: {
      return action.patient === null
        ? {
            patient: action.patient,
          }
        : {
            ...patient,
            ...action.patient,
          };
    }

    case types.ADD_STUDY: {
      return {
        ...patient,
        studies: patient && patient.studies ? [...patient.studies.filter((study) => study.StudyInstanceUID !== action.study.StudyInstanceUID), action.study] : [action.study],
      };
    }

    case types.SET_MAIN_STUDY_ID: {
      return {
        ...patient,
        mainStudyId: action.StudyInstanceUID,
      };
    }

    case types.SET_FETCHED_STUDIES: {
      const history = patient.patientHistory || [];
      const studies = action.studies || [];
      const filtered = studies.filter((item1) => history.find((item2) => item1.StudyInstanceUID === item2.StudyInstanceUID) === undefined);

      return {
        ...patient,
        patientHistory: [...history, ...filtered],
      };
    }

    default:
      return patient;
  }
};
